"use client";

import dynamic from "next/dynamic";

const PlanWaitlistFormInner = dynamic(() => import("./PlanWaitlistFormInner"), {
	ssr: false,
	loading: () => (
		<div className="flex w-full flex-col gap-6">
			{/* Full name */}
			<div className="flex flex-col gap-2.5">
				<div className="h-5 w-20 animate-pulse rounded bg-black/5" />
				<div className="h-9 w-full animate-pulse rounded-[9px] bg-black/5" />
			</div>
			{/* Email */}
			<div className="flex flex-col gap-2.5">
				<div className="h-5 w-12 animate-pulse rounded bg-black/5" />
				<div className="h-9 w-full animate-pulse rounded-[9px] bg-black/5" />
			</div>
			{/* Company */}
			<div className="flex flex-col gap-2.5">
				<div className="h-5 w-28 animate-pulse rounded bg-black/5" />
				<div className="h-9 w-full animate-pulse rounded-[9px] bg-black/5" />
			</div>
			{/* Website */}
			<div className="flex flex-col gap-2.5">
				<div className="h-5 w-16 animate-pulse rounded bg-black/5" />
				<div className="h-9 w-full animate-pulse rounded-[9px] bg-black/5" />
			</div>
			{/* Start date */}
			<div className="flex flex-col gap-2.5">
				<div className="h-5 w-48 animate-pulse rounded bg-black/5" />
				<div className="h-9 w-full animate-pulse rounded-[9px] bg-black/5" />
			</div>
			{/* Services */}
			<div className="flex flex-col gap-2.5">
				<div className="h-5 w-56 animate-pulse rounded bg-black/5" />
				<div className="flex flex-wrap gap-2">
					{Array.from({ length: 5 }).map((_, i) => (
						<div
							key={`skel-${i}`}
							className="h-8 w-20 animate-pulse rounded-lg bg-black/5"
						/>
					))}
				</div>
			</div>
		</div>
	),
});

interface PlanWaitlistFormProps {
	plan: string;
}

export default function PlanWaitlistForm({ plan }: PlanWaitlistFormProps) {
	return <PlanWaitlistFormInner plan={plan} />;
}
